<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> Settlement
      Form</a>
    <FormSettlementIssue v-model="data" @submit="onSubmit" ref="formSettlementIssue" />
  </main>
</template>
<script>
import FormSettlementIssue from "@/components/form/feedback/settlement-form"
import axios from '@/axios';
import { showErrorMessage } from '@/utils';
import { SETTLEMENT_PROCESS } from '@/components/form/feedback/constant.js'

export default {
  components: {
    FormSettlementIssue
  },
  data() {
    return {
      data: {
        no_crm: '',
        settlement: '',
        status: ''
      },
    }
  },
  computed: {
    AppActiveUser() { return this.$store.state.AppActiveUser },
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
  },
  async created() {
    await this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
    this.data.no_crm = this.detail?.id
    if (this.$route.name === 'FeedbackFormEditSettlement') {
      this.getDetail()
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formSettlementIssue.$validator.validateAll();
      if (isValid) {
        try {
          this.$store.dispatch('toggleLoadingProgress', true)

          await axios.post(`/fnc-settlements/${this.$route.params.id}`, this.data)
          this.$notify({ type: 'success', text: 'Success updating settlement issue' })
          this.$router.push(`/feedback/${this.$route.params.id}`)
        } catch (error) {
          showErrorMessage(error)
        } finally {
          this.$store.dispatch('toggleLoadingProgress', false)
        }
      }
    },

    async getDetail() {
      const { id } = this.$route.params
      this.$store.dispatch('toggleLoadingProgress', true)

      try {
        const { data: resData, status } = await axios.get(`/fnc-settlements/${id}`)
        if (status !== 200) return

        const { data } = resData
        this.data = {
          status: SETTLEMENT_PROCESS.find(({text}) => text.toLowerCase() == data?.follow_up_status.toLowerCase())?.value ?? '',
          no_crm: data?.no_crm,
          settlement: data?.settlement,
        }
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    }
  }
}
</script>

<style></style>
